<template>
  <v-modal
    v-if="show"
    :show="show"
    @update:show="$emit('update:show', $event)"
    :isTableModal="true"
  >
    <h4 slot="header" class="title title-up">Übergebene Parameter</h4>
    <div class="card-body">
      <table class="table">
        <thead>
          <tr>
            <th>Parameter</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(value, key) in parameters" :key="key">
            <td>{{ key }}</td>
            <td>{{ value }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-modal>
</template>

<script lang="babel">
import { Modal } from "src/components/UIComponents";

export default {
  components: {
    'v-modal': Modal
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    parameters() {
      return JSON.parse(this.$attrs.additional_affiliate_parameter.parameters);
    }
  }
};
</script>
